import { string } from 'yup';
import { uniq } from 'lodash-es';
import { useIntl } from 'react-intl';
import messages from '../messages.js';

function useSchema(currentRoles) {
  const currentNames = uniq(currentRoles.map((r) => [r.displayName, r.systemName]).flat().filter(Boolean).map((n) => n.toLowerCase()));
  const intl = useIntl();
  const validationSchema = string().trim().required().test(
    'no-duplicate-rolenames',
    intl.formatMessage(messages.duplicateRoleName),
    (name) => !currentNames.includes(name?.toLowerCase()),
  );
  const schema = {
    id: 'newRole',
    properties: [
      {
        id: 'name',
        type: 'string',
        label: messages.name,
        schema: validationSchema,

      },
    ],
  };
  return schema;
}

export default useSchema;
